// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1CoQO","detailsBorder":"styles_detailsBorder__3vByi"};